var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "product__success--section" }, [
    _c("div", { staticClass: "product__success--block" }, [
      _c("div", { staticClass: "product__success--black" }, [
        _c("div", { staticClass: "product__success--item" }, [
          !_vm.product.isPlan
            ? _c("h1", [
                _vm._v("Thank you for purchasing " + _vm._s(_vm.product.name))
              ])
            : _vm._e(),
          _vm.product.isPlan
            ? _c("h1", [
                _vm._v(
                  "Thank you for purchasing the " + _vm._s(_vm.product.name)
                )
              ])
            : _vm._e(),
          !_vm.licenseKey && !_vm.product.isPlan
            ? _c("h2", [_vm._v("Your license key has been emailed to you")])
            : _vm._e(),
          _vm.licenseKey
            ? _c("h2", [_vm._v("License Key: " + _vm._s(_vm.licenseKey))])
            : _vm._e(),
          _vm.product.isPlan && !_vm.product.isPersecond
            ? _c("h2", [
                _vm._v(
                  "Your plan will be activated momentarily. Download our apps below and sign in to make use of this plan."
                )
              ])
            : _vm._e(),
          _vm.product.isPlan && _vm.product.isPersecond
            ? _c("h2", [
                _vm._v(
                  "Your plan will be activated momentarily. Download our app below and sign in to make use of this plan."
                )
              ])
            : _vm._e()
        ]),
        !_vm.product.isPlan
          ? _c("div", { staticClass: "btn__group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--purpleLight",
                  on: {
                    click: function($event) {
                      _vm.goToLink(_vm.product.downloadUrl)
                    }
                  }
                },
                [_vm._v("Download")]
              ),
              _vm.activateUrl
                ? _c("a", { attrs: { href: _vm.activateUrl } }, [
                    _c("button", { staticClass: "btn btn--white" }, [
                      _vm._v("Activate your License")
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm.product.isPersecond
          ? _c("div", { staticClass: "btn__group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--purpleLight",
                  on: {
                    click: function($event) {
                      _vm.goToLink(_vm.product.downloadUrl)
                    }
                  }
                },
                [_vm._v("Download")]
              )
            ])
          : _vm._e()
      ]),
      _vm.product.isPlan
        ? _c(
            "div",
            _vm._l(_vm.otherProductsObj, function(product) {
              return _c(
                "div",
                { staticClass: "product__downloads--container" },
                [
                  _c("div", { staticClass: "product__item--img" }, [
                    _c("img", { attrs: { srcset: product.icon } })
                  ]),
                  _c("div", { staticClass: "product__item--title" }, [
                    _c("h2", [_vm._v(_vm._s(product.name))])
                  ]),
                  _c("div", { staticClass: "product__item--button" }, [
                    !product.isPlan
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--black",
                            on: {
                              click: function($event) {
                                _vm.goToLink(product.downloadUrl)
                              }
                            }
                          },
                          [_vm._v("Download")]
                        )
                      : _vm._e(),
                    product.isPlan
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--black",
                            attrs: { "ui-sref": "settings.flixel-cloud" }
                          },
                          [_vm._v("View Plan")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            })
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "product__success--block" }, [
      _vm.product.video
        ? _c("div", { staticClass: "product__success--white" }, [
            _c("div", { staticClass: "full__video" }, [
              _c("div", { staticClass: "fluid__video" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.product.video,
                    frameborder: "0",
                    allow: "autoplay"
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "video__text" }, [
              _c("h1", [_vm._v(_vm._s(_vm.product.name) + " tutorial")]),
              !_vm.product.isPlan
                ? _c("p", [
                    _vm._v(
                      "Watch this tutorial to learn how to create cinemagraphs with " +
                        _vm._s(_vm.product.name)
                    )
                  ])
                : _vm._e(),
              _vm.product.isPlan
                ? _c("p", [
                    _vm._v(
                      "Watch this tutorial to learn how to create cinemagraphs with the " +
                        _vm._s(_vm.product.name)
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ]),
    !_vm.product.isPlan
      ? _c(
          "div",
          { staticClass: "product__success--block" },
          [
            _vm._m(0),
            _vm._l(_vm.otherProductsObj, function(product) {
              return _c(
                "div",
                { staticClass: "product__downloads--container" },
                [
                  _c("div", { staticClass: "product__item--img" }, [
                    _c("img", { attrs: { srcset: product.icon } })
                  ]),
                  _c("div", { staticClass: "product__item--title" }, [
                    _c("h2", [_vm._v(_vm._s(product.name))])
                  ]),
                  _c("div", { staticClass: "product__item--button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--black",
                        on: {
                          click: function($event) {
                            _vm.goToLink(product.downloadUrl)
                          }
                        }
                      },
                      [_vm._v("Download")]
                    ),
                    product.isPlan
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--black",
                            on: {
                              click: function($event) {
                                _vm.goToLink(_vm.settings.flixel - _vm.cloud)
                              }
                            }
                          },
                          [_vm._v("View Plan")]
                        )
                      : _vm._e()
                  ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product__downloads" }, [
      _c("h1", [_vm._v("Check out some of the other Flixel products")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f021116", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f021116","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/productSuccess.vue
// module id = null
// module chunks = 